module.exports = __webpack_public_path__ + "kudos_25.svg?7dc521d802db33d06cb9fef3cb7f474f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_25.svg
// module id = 123
// module chunks = 0